import { render, staticRenderFns } from "./SettingsFavorites.vue?vue&type=template&id=56736740&scoped=true"
import script from "./SettingsFavorites.vue?vue&type=script&lang=js"
export * from "./SettingsFavorites.vue?vue&type=script&lang=js"
import style0 from "./SettingsFavorites.vue?vue&type=style&index=0&id=56736740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56736740",
  null
  
)

export default component.exports